module.exports = function () {
	Innophos.Pages.SearchPage.Search(function (results) {
		var $content = $('.search-page__inner');
		$content.html(results);

		Innophos.Pages.SearchPage.Init();

		$('html, body').animate({ scrollTop: 0 });
	});
};
